import { HttpClient } from '@angular/common/http';
import BigNumber from 'bignumber.js';
import { tap } from 'rxjs/operators';
import { Base } from '../base';

export class TokenBalances extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/token_balances`);
  }

  get(id: string) {
    return this.api.get(id).pipe(
      tap((json) => this.processRecord(json.tokenBalance))
    )
  }

  private processRecord(record: any) {
    record.amount = new BigNumber(record.amount).fromDecimal();
  }
}
